var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _vm.hasPermissions
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("SubtractPurchasesFromProfit"),
                        },
                        model: {
                          value: _vm.settings.SubtractPurchasesFromProfit,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settings,
                              "SubtractPurchasesFromProfit",
                              $$v
                            )
                          },
                          expression: "settings.SubtractPurchasesFromProfit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("SubtractSaleBuyPriceFromProfit"),
                        },
                        model: {
                          value: _vm.settings.SubtractSaleBuyPriceFromProfit,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settings,
                              "SubtractSaleBuyPriceFromProfit",
                              $$v
                            )
                          },
                          expression: "settings.SubtractSaleBuyPriceFromProfit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-type-multi-select", {
                        attrs: {
                          fancy: "",
                          "use-id": "",
                          label: _vm.$ct("to-use-sale-types"),
                        },
                        model: {
                          value: _vm.settings.ToComputeSaleTypes,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "ToComputeSaleTypes", $$v)
                          },
                          expression: "settings.ToComputeSaleTypes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      attrs: { disabled: !_vm.items || !_vm.canEditCurrentTab },
                      on: {
                        click: function ($event) {
                          return _vm.addCustomItem()
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "plus" } }),
                      _vm._v(
                        " " + _vm._s(_vm.$ct("dashboard-add-custom-item"))
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-sortable",
        {
          attrs: { tag: "w-list", items: _vm.tabs, "target-class": "handle" },
          on: {
            drop: function ($event) {
              return _vm.onNewOrder()
            },
          },
        },
        [
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "w-list-item",
              { key: tab.uid, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(tab.Name))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-tab"),
                            expression: "$ct('edit-tab')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editTab(tab)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _vm.canShareTab(tab)
                  ? _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("share-tab"),
                                expression: "$ct('share-tab')",
                              },
                            ],
                            staticClass: "warning",
                            on: {
                              click: function ($event) {
                                return _vm.shareTab(tab)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "share" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("delete-tab"),
                            expression: "$ct('delete-tab')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { disabled: _vm.tabs.length <= 1 },
                        on: {
                          click: function ($event) {
                            return _vm.deleteTab(tab)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.createTab()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("create-new-tab"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditTab != null } },
        [
          _vm.toEditTab
            ? _c("app-edit-tab", {
                attrs: { "is-new": _vm.isNewTab },
                on: {
                  close: function ($event) {
                    _vm.toEditTab = null
                  },
                  save: function ($event) {
                    return _vm.saveTab($event)
                  },
                },
                model: {
                  value: _vm.toEditTab,
                  callback: function ($$v) {
                    _vm.toEditTab = $$v
                  },
                  expression: "toEditTab",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createItemModal,
            callback: function ($$v) {
              _vm.createItemModal = $$v
            },
            expression: "createItemModal",
          },
        },
        [
          _vm.createItemModal && _vm.items
            ? _c("app-create-dashboard-item", {
                attrs: { "ignored-type-ids": [10], items: _vm.items },
                on: {
                  close: function ($event) {
                    _vm.createItemModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.toShareTab
        ? _c("app-dashboard-tab-share-settings", {
            attrs: { tab: _vm.toShareTab },
            on: {
              close: function ($event) {
                _vm.toShareTab = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }